<template>
    <div id="customer-manage">
        <div class="flex items-center justify-between">
            <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="addCustomer">
                Thêm mới khách hàng
            </vs-button>
            <h3 class="text-primary text-center flex-1 text-center"
                style="transform: translateX(-50%);left: 50%;position: absolute;">DANH SÁCH KHÁCH HÀNG 
            </h3>
        </div>
        <div class="vx-card px-6 py-4">
            <div class="mt-8">
                <vs-table v-model="dataCustomerSelected" :data="customerData" noDataText="Không có dữ liệu">
                    <template slot="thead">
                        <vs-th>
                            STT
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Mã KH</label>
                                <vs-input v-model="nanoCustomerCode" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Tên KH</label>
                                <vs-input v-model="fullName" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Ngày sinh</label>
                                <div class="flex relative" style="width: 150px">
                                    <vs-input v-model="dayBirthday" @keyup.enter="filterManage"
                                        placeholder="Ngày"></vs-input>
                                    <vs-input v-model="monthBirthday" @keyup.enter="filterManage"
                                        placeholder="Tháng"></vs-input>
                                    <vs-input v-model="yearBirthday" @keyup.enter="filterManage"
                                        placeholder="Năm"></vs-input>
                                </div>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Giới tính</label>
                                <v-select class="relative" style="width: 100px" v-model="gender"
                                    :options="genderOptions" :reduce="item => item.value" :clearable="false"
                                    @input="filterManage"></v-select>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>SĐT</label>
                                <vs-input v-model="phoneNumber" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Nguồn KH</label>
                                <v-select class="relative" style="width: 200px" v-model="sourceType"
                                    :options="sourceTypeOptionsManage" :reduce="item => item.value" :clearable="false"
                                    @input="filterManage"></v-select>

                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Địa chỉ</label>
                                <vs-input v-model="fullAddress" @keyup.enter="filterManage"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Loại KH</label>
                                <v-select class="relative" style="width: 200px" v-model="type" :options="typeOptions"
                                    :reduce="item => item.value" :clearable="false"></v-select>

                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Đăng nhập lần đầu</label>
                                <div class="flex relative" style="width: 200px">
                                    <datepicker :highlighted="highlightedFn" :language="vi"
                                        :disabled-dates="disabledDates" :format="'dd/MM/yyyy'"
                                        v-model="startDateFirstLogin" name="startDateFirstLogin" class="mr-1"
                                        placeholder="Bắt đầu" @input="dateFirstLogin">
                                    </datepicker>
                                    <datepicker :highlighted="highlightedFn" :language="vi"
                                        :disabled-dates="disabledDates" :format="'dd/MM/yyyy'"
                                        v-model="endDateFirstLogin" name="endDateFirstLogin" placeholder="Kết thúc"
                                        @input="dateFirstLogin">
                                    </datepicker>
                                </div>
                            </div>
                        </vs-th>
                        <vs-th>
                            <div>
                                <label>Đăng nhập lần cuối</label>
                                <div class="flex relative" style="width: 200px">
                                    <datepicker :highlighted="highlightedFn" :language="vi"
                                        :disabled-dates="disabledDates" :format="'dd/MM/yyyy'"
                                        v-model="startDateLastLogin" name="startDateLastLogin" class="mr-1"
                                        placeholder="Bắt đầu" @input="dateLastLogin">
                                    </datepicker>
                                    <datepicker :highlighted="highlightedFn" :language="vi"
                                        :disabled-dates="disabledDates" :format="'dd/MM/yyyy'"
                                        v-model="endDateLastLogin" name="endDateLastLogin" placeholder="Kết thúc"
                                        @input="dateLastLogin">
                                    </datepicker>
                                </div>
                            </div>
                        </vs-th>
                        <vs-th>
                            Hành động
                        </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ tr.stt }}
                            </vs-td>

                            <vs-td>
                                {{ tr.nanoCustomerCode }}
                            </vs-td>

                            <vs-td class="text-primary cursor-pointer hover:font-semibold hover:underline">
                                <span @click="detailsRecord(tr)">{{ tr.fullName }}</span>
                            </vs-td>

                            <vs-td>
                                {{ tr.birthdayStr }}
                            </vs-td>
                            <vs-td>
                                {{ tr.genderStr }}
                            </vs-td>
                            <vs-td>
                                {{ tr.phoneNumberCvt }}
                            </vs-td>
                            <vs-td>
                                {{ tr.sourceTypeText }}
                            </vs-td>
                            <vs-td>
                                {{ tr.fullAddress }}
                            </vs-td>
                            <vs-td>
                                <vs-chip class="ag-grid-cell-chip-customer" :color="chipColor(tr.type)">
                                    <span>{{ checkStatus(tr.type) }}</span>
                                </vs-chip>
                            </vs-td>
                            <vs-td>
                                {{ tr.firstLoginStr }}
                            </vs-td>
                            <vs-td>
                                {{ tr.lastLoginStr }}
                            </vs-td>
                            <vs-td>
                                <vx-tooltip class="position-icon" text="Ghi chú" position="top">
                                    <feather-icon icon="EditIcon" class="action-success mt-3"
                                        svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                        @click="openPopupNote(tr)" />
                                </vx-tooltip>

                                <vx-tooltip class="position-icon" :text="$t('button.call')" position="top"
                                    v-if="userInfo.userRole == 'user' && isPermissionCall">
                                    <feather-icon icon="PhoneIcon" class="action-success icon-btn mt-3"
                                        svgClasses="h-5 w-5 cursor-pointer" @click="callToCustomer(tr)" />
                                </vx-tooltip>

                                <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                                    <feather-icon icon="EyeIcon" class="text-primary mt-3"
                                        svgClasses="h-5 w-5 hover:text-success icon-btn" @click="detailsRecord(tr)" />
                                </vx-tooltip>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>


            <div class="vx-row mt-4" v-if="customerData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        customerData.length - currentPageManage * pageSizeManage > 0 ? currentPageManage *
                                            pageSizeManage
                                            : customerData.length
                                    }} /
                                    {{ totalElementsManage }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSizeManage(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSizeManage(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPagesManage" v-model="currentPageManage" @change="loadPageManage" />
                </div>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp khách hàng" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" noDataText="Không có dữ liệu" pagination max-items="5">
                        <template slot="thead">
                            <vs-th> STT</vs-th>
                            <vs-th> Trường dữ liệu</vs-th>
                            <vs-th> Hàng</vs-th>
                            <vs-th> Cột</vs-th>
                            <vs-th> Lỗi</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Ghi chú" :active.sync="popupNote" id="customer_note" v-if="popupNote">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea class="w-full" v-model="customerDetails.note" />
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full flex justify-end">
                    <vs-button class="mr-4" color="primary" @click="saveInfoCustomer">Lưu</vs-button>
                    <vs-button type="border" color="danger" @click="popupNote = false">Đóng</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup class="holamundo customer-info" title="Khách hàng" :active.sync="popupInfo" id="customer_info_popup"
            v-if="popupInfo">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <CustomerInformation :loyaltyCustomerId="dataRow.id"></CustomerInformation>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <HistorySMS :loyaltyCustomerId="dataRow.id"></HistorySMS>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <CallHistory :phone="dataRow.phoneNumber"></CallHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử đặt lịch">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <BookingHistory :loyaltyCustomerId="dataRow.id"></BookingHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử ra vào">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <InOutHistory :loyaltyCustomerId="dataRow.id"></InOutHistory>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <ConsultingStep :loyaltyCustomerId="dataRow.id"></ConsultingStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <FeeCollectionStep :loyaltyCustomerId="dataRow.id"></FeeCollectionStep>
                    </VuePerfectScrollbar>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                    <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown scroll"
                        :settings="settings">
                        <SubclinicalStep :loyaltyCustomerId="dataRow.id"></SubclinicalStep>
                    </VuePerfectScrollbar>
                </vs-tab>



            </vs-tabs>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap justify-end gap-4">
                        <vs-button icon-pack="feather" icon="icon-calendar" @click="openPopupBooking"
                            v-if="isPermissionCreateBooking">Đặt lịch
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-phone-call" @click="callToCustomer(null)"
                            v-if="userInfo.userRole == 'user' && isPermissionCall">Gọi điện
                        </vs-button>
                        <vs-button icon-pack="feather" icon="icon-mail" @click="sendSMS">Gửi SMS</vs-button>
                        <vs-button icon-pack="feather" icon="icon-x" color="danger" type="border"
                            @click="popupInfo = false">Đóng
                        </vs-button>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" title="Gửi SMS" :active.sync="popupSendSMSCustomer" id="send_sms_customer">
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Tổng đài</label>
                        <v-select class="w-full" v-model="smsSendInfo.smsBrandNameId" :options="brandNameOptions"
                            :reduce="item => item.value">
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Nội dung</label>
                        <vs-textarea class="w-full" v-model="smsSendInfo.messageTitle" />
                    </div>
                    <div class="vx-col w-full">
                        <div class="flex justify-end gap-4">
                            <vs-button icon-pack="feather" icon="icon-send" @click="send">Gửi</vs-button>
                            <vs-button icon-pack="feather" icon="icon-x" type="border" color="danger"
                                @click="cancelSend">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" title="Đặt lịch" :active.sync="popupBooking" id="popup_beauty_booking"
                v-if="popupBooking">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">Chi nhánh</label>
                        <v-select v-model="selectedBranchCreate" :options="branchCreateOptions" :clearable="false"
                            v-validate="'required'" name="branch">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <div class="vx-col w-full mt-6">
                        <vs-radio v-model="packageType" vs-value="1" class="mr-4" @change="changeSelectType">Nhóm dịch
                            vụ
                        </vs-radio>
                        <vs-radio v-model="packageType" vs-value="2" @change="changeSelectType">Gói dịch vụ
                        </vs-radio>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 1">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Nhóm dịch vụ</label>
                                <v-select v-model="selectBeautyService" :options="beautyServiceData" :clearable="false"
                                    v-validate="''" name="nameServiceType">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('nameServiceType') }}</span> -->
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label required">Dịch vụ</label>
                                <v-select v-model="selectBeautyServicePackage" :options="beautyServicePackageOptions"
                                    :clearable="false" v-validate="''" name="nameServicePacks">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('nameServicePacks') }}</span> -->
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label">Bác sĩ</label>
                                <v-select class="w-full" v-model="selectedDoctorCreate" :options="doctorCreateOptions"
                                    :clearable="false" v-validate="''" name="doctor">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('doctor') }}</span>
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label class="vs-input--label">Ghi chú</label>
                                <vs-input class="w-full" v-model="note"></vs-input>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="packageType == 2">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <label class="vs-input--label required">Gói dịch vụ</label>
                                <v-select v-model="selectedComboService" :options="beautyComboService"
                                    :clearable="false" v-validate="''" name="comboService">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                                <!-- <span class="text-danger text-sm">{{ errors.first('comboService') }}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Ngày</label>
                        <div class="w-full">
                            <datepicker :highlighted="highlighted" class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                v-model="selectDate" data-vv-validate-on="input" ref="datepickBooking"
                                v-validate="'required'" name="time">
                            </datepicker>
                            <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-1/2 mt-4">
                        <label class="vs-input--label">Giờ</label>
                        <div class="w-full">
                            <flat-pickr :config="configTimePickerBooking" v-model="selectTime"
                                class="w-full vs-inputx vs-input--input normal" name="time"></flat-pickr>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <div class="flex flex-wrap float-right">
                            <vs-button color="primary" class="mt-6 text-center mr-2" @click="saveBooking"
                                :disabled="!validateForm">Tạo mới
                            </vs-button>
                            <vs-button color="warning" type="border" class="mt-6 text-center"
                                @click="popupBooking = false">Hủy
                            </vs-button>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from "moment";
import authConfig from '@/../auth_config.json';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { isAPI } from "../../../../store/permission";
import { constAPI } from "../../../../store/constant";
import Datepicker from 'vuejs-datepicker';
import { en, vi } from "vuejs-datepicker/dist/locale";

import ConsultingStep from "./cell-renderer/medical-step/ConsultingStep";
import FeeCollectionStep from "./cell-renderer/medical-step/FeeCollectionStep";
import SubclinicalStep from "./cell-renderer/medical-step/SubclinicalStep";
import HistorySMS from "./cell-renderer/history-sms/HistorySMS";
import InOutHistory from "./cell-renderer/medical-step/InOutHistory";
import BookingHistory from "./cell-renderer/medical-step/BookingHistory";
import CustomerInformation from "./CustomerInformation";
import CallHistory from "./cell-renderer/medical-step/CallHistory";

export default {
    components: {
        vSelect,
        VuePerfectScrollbar,
        flatPickr,
        Datepicker,
        ConsultingStep,
        FeeCollectionStep,
        SubclinicalStep,
        HistorySMS,
        InOutHistory,
        BookingHistory,
        CustomerInformation,
        CallHistory,
    },
    data() {
        return {
            customerData: [],
            pageNumberManage: 0,
            pageSizeManage: 30,
            totalPagesManage: 0,
            currentPageManage: 1,
            listCards: [],
            branchOptions: [],
            selectedBranchValue: null,
            files: null,
            totalElementsManage: 0,
            sourceTypeOptionsManage: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Phòng kinh doanh 1' },
                { value: 2, label: 'Phòng kinh doanh 2' },
                { value: 3, label: 'Nhân viên' },
                { value: 4, label: 'Phòng kinh doanh 3' },
                { value: 5, label: 'Phòng kinh doanh 4' },
                { value: 6, label: 'Nguồn khác' },
                { value: 7, label: 'Nguồn App' },
            ],
            typeOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Khách hàng chính thức' },
                { value: 2, label: 'Khách hàng tiềm năng' },
                { value: 3, label: 'Khách hàng cơ hội' },
            ],
            popupErrorImport: false,
            errorData: [],
            departmentDataManage: [],
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },

            activePopupCall: false,
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            popupCreateFile: false,
            createdDate: new Date(),
            configDatePicker: {
                dateFormat: 'd-m-Y',
            },
            customerTypeOptions: [
                { value: 1, label: "Khách hàng cũ tới tái khám" },
                { value: 2, label: "Khách hàng cũ sử dụng dịch vụ" },
                { value: 3, label: "Khách hàng cũ tới tư vấn dv" },
                { value: 4, label: "Khách hàng mới đến tư vấn" },
                { value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm" },
                { value: 6, label: "Khách hàng trả lại thuốc" },
                { value: 7, label: "Khách hàng tới hoàn phí" },
            ],
            selectedCustomerTypeValue: null,
            healthInsuranceNum: null,
            reasonForExamination: null,
            noteReason: null,
            stepOptions: [
                { value: 1, label: 'Tiếp đón' },
                { value: 2, label: 'Tư vấn' },
                { value: 3, label: 'Thu phí' },
                { value: 4, label: 'Cận lâm sàng' },
                { value: 5, label: 'Hoàn thành' },
            ],
            selectedStepValue: null,
            selectedEmployeeValue1: null,
            selectedEmployeeValue2: null,
            selectedDoctorValue: null,
            popupNote: false,
            customerDetails: null,
            popupInfo: false,
            organizationBranchOptions: [],
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: "Việt Nam",
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null,
                sourceType: null,
            },
            images: [],
            user_data: null,
            imagesId: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                { value: null, label: 'Tất cả' },
                { value: 0, label: this.$t('genderOption.unknown') },
                { value: 1, label: this.$t('genderOption.male') },
                { value: 2, label: this.$t('genderOption.female') }
            ],
            customerId: null,
            configDatePickerInfo: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
            typeCustomer: [
                { value: 1, label: 'Khách hàng chính thức' },
                { value: 2, label: 'Khách hàng tiềm năng' },
            ],
            sourceTypeOptions: [
                { value: 2, label: 'Nguồn phòng ban' },
                { value: 3, label: 'Nguồn cá nhân' },
            ],
            departmentData: [],
            showSelectedSourceType: false,
            employeeInfo: null,
            autoCreateMedicalRecordCheck: false,


            activeTab: 0,
            brandNameOptions: [],
            popupSendSMSCustomer: false,
            configTimePicker: {
                minDate: new Date(),
                enableTime: true,
                time_24hr: true,
                locale: Vietnamese,
            },
            smsSendInfo: {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            },

            // Querry
            nanoCustomerCode: null,
            fullName: null,
            gender: null,
            phoneNumber: null,
            sourceType: null,
            job: null,
            fullAddress: null,
            email: null,
            type: null,
            startDateBirthday: null,
            endDateBirthday: null,
            startDateFirstLogin: null,
            endDateFirstLogin: null,
            startDateLastLogin: null,
            endDateLastLogin: null,
            dayBirthday: null,
            monthBirthday: null,
            yearBirthday: null,
            note:'',
            dataRow: null,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            dataCustomerSelected: [],

            //Booking
            branchCreateOptions: [],
            popupBooking: false,
            beautyServicePackageData: [],
            beautyServiceData: [],
            selectBeautyServiceValue: null,
            beautyServicePackageOptions: [],
            selectBeautyServicePackageValue: null,
            selectedDoctorCreateValue: null,
            doctorCreateOptions: [],
            selectedBranchCreateValue: null,
            selectDate: new Date(),
            selectTime: new Date(),
            configTimePickerBooking: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            packageType: 1,
            beautyComboService: [],
            selectedComboServiceValue: null,
        }
    },
    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });

        this.branchOptions.unshift({ value: null, label: 'Tất cả' })
        await this.getDepartmentData();
        this.findCustomerData();
    },
    watch: {
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.filterManage();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },
    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },

        chipColor() {
            return value => {
                if (value === 1) {
                    return "success";
                } else {
                    return 'warning'
                }
            }
        },
        checkStatus() {
            return value => {
                if (value === 1) {
                    return 'Chính thức'
                } else {
                    return 'Tiềm năng'
                }
            }
        },
        isPermissionCall() {
            return isAPI(this, constAPI.beauty_call)
        },

        //Booking
        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },
        selectedBranchCreate: {
            get() {
                let obj = this.branchCreateOptions.find(x => x.value === this.selectedBranchCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedBranchCreateValue = obj ? obj.value : null;
                this.selectBeautyServiceValue = null;
                this.selectedComboServiceValue = null;
                if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
                if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
                this.doctorCreateOptions = [];
                await this.$validator.reset();
            }
        },
        selectBeautyService: {
            get() {
                let obj = this.beautyServiceData.find(x => x.value === this.selectBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },
        selectBeautyServicePackage: {
            get() {
                let obj = this.beautyServicePackageOptions.find(x => x.value === this.selectBeautyServicePackageValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectBeautyServicePackageValue = obj ? obj.value : null;
                this.selectedDepartmentCreateValue = obj ? obj.departmentId : null;
                this.getDoctor();
            }
        },
        selectedDoctorCreate: {
            get() {
                let obj = this.doctorCreateOptions.find(x => x.value === this.selectedDoctorCreateValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorCreateValue = obj ? obj.value : null;
            }
        },
        selectedComboService: {
            get() {
                let obj = this.beautyComboService.find(x => x.value === this.selectedComboServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedComboServiceValue = obj ? obj.value : null;
            }
        },
        validateForm() {
            return !this.errors.any();
        },
    },
    methods: {
        addCustomer() {
            this.$router.push(`/user/add-customer`).catch(() => {
            });
        },

        findCustomerData() {
            const payload = {};
            payload['pageNumber'] = this.pageNumberManage;
            payload['pageSize'] = this.pageSizeManage;
            if (this.selectedBranchValue) payload['organizationBranchId'] = this.selectedBranchValue;
            if (this.nanoCustomerCode) payload['nanoCustomerCode'] = this.nanoCustomerCode;
            if (this.fullName) payload['fullName'] = this.fullName;
            if (this.startDateBirthday) payload['startDateBirthday'] = this.startDateBirthday;
            if (this.endDateBirthday) payload['endDateBirthday'] = this.endDateBirthday;
            if (this.gender) payload['gender'] = this.gender;
            if (this.sourceType) payload['source'] = this.sourceType;
            if (this.phoneNumber) payload['phoneNumber'] = this.phoneNumber;
            if (this.job) payload['job'] = this.job;
            if (this.fullAddress) payload['fullAddress'] = this.fullAddress;
            if (this.email) payload['email'] = this.email;
            if (this.type) payload['type'] = this.type;
            if (this.startDateFirstLogin) payload['startDateFirstLogin'] = this.startDateFirstLogin;
            if (this.endDateFirstLogin) payload['endDateFirstLogin'] = this.endDateFirstLogin;
            if (this.startDateLastLogin) payload['startDateLastLogin'] = this.startDateLastLogin;
            if (this.endDateLastLogin) payload['endDateLastLogin'] = this.endDateLastLogin;
            if (this.dayBirthday) {
                this.dayBirthday = this.dayBirthday.toString();
                if (this.dayBirthday.length === 1) {
                    payload['dayBirthday'] = '0' + this.dayBirthday;
                } else {
                    payload['dayBirthday'] = this.dayBirthday;
                }
            }
            if (this.monthBirthday) {
                this.monthBirthday = this.monthBirthday.toString();
                if (this.monthBirthday.length === 1) {
                    payload['monthBirthday'] = '0' + this.monthBirthday;
                } else {
                    payload['monthBirthday'] = this.monthBirthday;
                }
            }
            if (this.yearBirthday) payload['yearBirthday'] = this.yearBirthday;
            if (this.sourceType === 5 || this.sourceType === 6) {
                payload['sourceType'] = 2;
                if (this.sourceType === 5) {
                    let department = this.departmentDataManage.find(el => el.type === 1);
                    payload['departmentId'] = department ? department.id : 0;
                }
                if (this.sourceType === 6) {
                    let department = this.departmentDataManage.find(el => el.type === 2);
                    payload['departmentId'] = department ? department.id : 0;
                }
            } else {
                if (this.sourceType) payload['sourceType'] = this.sourceType;
            }

            const params = new URLSearchParams(payload).toString();
            this.$vs.loading();
            this.$crm.get(`/loyalty/customer/find?${params}`).then(response => {
                this.$vs.loading.close();
                if (response.data.content && response.data.content.length > 0) {
                    this.customerData = response.data.content.map(t => {
                        t.stt = this.pageSizeManage * this.pageNumberManage + response.data.content.indexOf(t) + 1;
                        t.created_at_display = t.createdDate ? moment(t.createdDate).format("DD/MM/YYYY HH:mm:ss") : null;
                        t.cardNumber = t.card ? t.card.number : null;
                        t.points = t.card ? t.card.points : null;
                        t.phoneNumberCvt = t.phoneNumber ? this.convertPhone(t.phoneNumber) : null;
                        if (t.sourceType !== 2) {
                            t.sourceTypeText = t.sourceType === 1 ? 'Nguồn app' : (t.sourceType === 3) ? 'Nguồn nhân viên' : 'Nguồn khác';
                        } else {
                            t.sourceTypeText = t.department ? t.department.departmentName : null;
                        }
                        let timezone = new Date().getTimezoneOffset() / 60,
                            utc = null;
                        if (timezone < 0) utc = Math.abs(timezone).toString().length > 1 ? `+${Math.abs(timezone)}` : `+0${Math.abs(timezone)}`;
                        if (timezone > 0) utc = Math.abs(timezone).toString().length > 1 ? `-${Math.abs(timezone)}` : `-0${Math.abs(timezone)}`;
                        t.birthdayStr = t.birthday ? moment(t.birthday).utcOffset(utc).format('DD/MM/YYYY') : null;
                        t.genderStr = t.gender === 0 ? this.$t('genderOption.unknown') : t.gender === 1 ? this.$t('genderOption.male') : t.gender === 2 ? this.$t('genderOption.female') : null;
                        t.firstLoginStr = t.firstLogin ? moment(t.firstLogin).format('DD/MM/YYYY') : null;
                        t.lastLoginStr = t.lastLogin ? moment(t.lastLogin).format('DD/MM/YYYY') : null;
                        return t;
                    })
                } else {
                    this.customerData = [];
                }

                this.totalPagesManage = response.data.totalPages;
                this.totalElementsManage = response.data.totalElements;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadPageManage: function (currentPage) {
            if (this.pageNumberManage !== parseInt(currentPage) - 1) {
                this.pageNumberManage = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.findCustomerData();
            }
        },

        changePageSizeManage(number) {
            this.pageSizeManage = number;
            this.pageNumberManage = 0;
            this.currentPageManage = 1;
            this.findCustomerData();
        },

        downloadFile() {
            this.$vs.loading();
            this.$crm.post('/loyalty/customer/download-template-customer').then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        isExcel(file) {
            return /\.(xlsx)$/.test(file.name)
        },

        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.selectedBranchValue) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Hãy chọn chi nhánh cần thêm khách hàng trước khi tải lên tệp khách hàng!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            if (!this.isExcel(file[0])) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('files', file[0]);
            formData.append('organizationBranchId', this.selectedBranchValue);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post('/loyalty/customer/import-excel', formData).then(res => {
                if (res.data.data && res.data.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.data.map(el => {
                        el.stt = res.data.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.$vs.notify({
                        title: 'Thành công',
                        text: 'Tải lên tệp khách hàng thành công!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    });
                    this.findCustomerData();
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },

        async filterManage() {
            // await this.dateBirthday();
            await this.dateFirstLogin();
            await this.dateLastLogin();
            this.currentPageManage = 1;
            this.pageNumberManage = 0;
            this.findCustomerData();
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', { organizationBranchId: userInfo.organizationBranchId, }).then(res => {
                    this.departmentDataManage = res.data;
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async detailsRecord(data) {
            this.dataRow = data;
            this.activeTab = 0;
            this.popupInfo = true;
        },
        callToCustomer(data) {
            let dataRow = data ? data : this.dataRow;
            dataRow['isCreateBooking'] = true;
            this.$eventBus.$emit("beauty-call", dataRow);
        },
        openPopupNote(data) {
            this.customerDetails = data;
            this.popupNote = true;
        },
        saveInfoCustomer() {
            this.$vs.loading();
            this.$crm.post(`/loyalty/customer/update-note/${this.customerDetails.id}`, this.customerDetails).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: this.$t('menuCustomer.updateCustomerSS'),
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.popupNote = false;
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        //Send SMS
        async sendSMS() {
            await this.getBrandName();
            this.popupSendSMSCustomer = true;
        },
        getBrandName() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/sms-brand-name/get-all').then(res => {
                    if (res.data && res.data.length > 0) {
                        this.brandNameOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.brandName,
                            }
                        })
                    }
                    this.$vs.loading.close();
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        cancelSend() {
            this.smsSendInfo = {
                smsBrandNameId: null,
                messageType: null,
                sendTimeStr: null,
                messageTitle: null,
            }
            this.popupSendSMSCustomer = false;
        },
        send() {
            let payload = {
                messageType: 1,
                loyaltyCustomerIds: [this.dataRow.id],
                message: this.smsSendInfo.messageTitle,
                smsBrandNameId: this.smsSendInfo.smsBrandNameId,
                sendTimeStr: moment(new Date().toISOString()).format('yyyyMMDDHHmmss'),
                sendStatus: 1,
            }
            this.$vs.loading();
            this.$crm.post('/sms-message-config/create', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Gửi tin nhắn thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.cancelSend();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // End Send

        dateFirstLogin() {
            return new Promise((resolve, reject) => {
                if (this.startDateFirstLogin) this.startDateFirstLogin = new Date(new Date(this.startDateFirstLogin).setHours(0, 0, 0, 0));
                if (this.endDateFirstLogin) this.endDateFirstLogin = new Date(new Date(this.endDateFirstLogin).setHours(0, 0, 0, 0));
                if (this.startDateFirstLogin && this.endDateFirstLogin && (this.startDateFirstLogin.getTime() > this.endDateFirstLogin.getTime())) {
                    reject();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                resolve();
            })
        },

        dateLastLogin() {
            return new Promise((resolve, reject) => {
                if (this.startDateLastLogin) this.startDateLastLogin = new Date(new Date(this.startDateLastLogin).setHours(0, 0, 0, 0));
                if (this.endDateLastLogin) this.endDateLastLogin = new Date(new Date(this.endDateLastLogin).setHours(0, 0, 0, 0));
                if (this.startDateLastLogin && this.endDateLastLogin && (this.startDateLastLogin.getTime() > this.endDateLastLogin.getTime())) {
                    reject();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                resolve();
            })
        },

        openPopupBooking() {
            this.$validator.reset();
            this.selectedStatusBeautyValue = null;
            this.selectedBranchCreateValue = null;
            this.selectedCustomerCreateValue = null;
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;

            this.beautyServicePackageOptions = [];
            this.beautyServiceData = [];
            this.doctorCreateOptions = [];
            this.beautyComboService = [];

            this.selectDate = new Date();
            this.selectTime = new Date();

            this.branchCreateOptions = this.branchOptions.filter(x => x.value);

            this.popupBooking = true;
        },

        async changeSelectType() {
            this.selectBeautyServiceValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedDoctorCreateValue = null;
            this.selectedDepartmentCreateValue = null;
            this.selectBeautyServicePackageValue = null;
            this.selectedComboServiceValue = null;

            if (this.selectedBranchCreateValue && this.packageType == 1) await this.getBeautyService();
            if (this.selectedBranchCreateValue && this.packageType == 2) await this.getBeautyComboService();
        },

        getBeautyService(dataService, organizationBranchId) {
            return new Promise((resolve, reject) => {
                this.beautyServiceData = [];
                let payload = {
                    organizationBranchId: !this.isUpdateBooking ? this.selectedBranchCreateValue : organizationBranchId,
                    keySearch: dataService ? dataService.beautyService.name : null,
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    res.data.content.map(x => {
                        let data = this.beautyServiceData.find(t => t.value == x.id);
                        if (!data) {
                            let result = {
                                value: x.id,
                                label: x.code + '-' + x.name,
                            }
                            this.beautyServiceData.push(result);
                        }
                    })
                    this.beautyServiceData = Array.from(new Set(this.beautyServiceData));
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    organizationBranchId: this.selectedBranchCreateValue,
                    beautyServiceId: this.selectBeautyServiceValue,
                    active: this.isUpdateBooking ? -1 : null,
                };
                this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackageOptions = res.data.content.map(el => {
                        return {
                            value: el.beautyServicePackage.id,
                            label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
                            departmentId: el.beautyServicePackage.departmentId,
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getBeautyComboService() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/beauty-package-combo/find-by-condition', { organizationBranchId: this.selectedBranchCreateValue }).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyComboService = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getDoctor() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                this.doctorCreateOptions = [];
                if (this.selectedBranchCreateValue) {
                    url += '?organizationBranchId=' + this.selectedBranchCreateValue
                }
                if (this.selectedDepartmentCreateValue) {
                    url += '&departmentId=' + this.selectedDepartmentCreateValue
                }

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorCreateOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        async saveBooking(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.packageType == 1 && !this.selectBeautyServicePackageValue) {
                return this.$vs.notify({
                    text: 'Dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.packageType == 2 && !this.selectedComboServiceValue) {
                return this.$vs.notify({
                    text: 'Gói dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                    color: 'danger'
                });
            }

            let payload = {
                organizationBranchId: this.selectedBranchCreateValue,
                loyaltyCustomerId: this.dataRow.id,
                isDoctorCreate: true,
                packageType: this.packageType,
                presentStatus: 0,
                note:this.note,
                beautyBookingDetails: [
                    {
                        beautyServicePackageId: this.selectBeautyServicePackageValue,
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorCreateValue,
                        startTime: this.selectTime,
                        beautyPackageComboId: this.selectedComboServiceValue,
                    }
                ]
            }

            let checkDate = new Date(new Date(this.selectDate).setHours(parseInt(this.selectTime.substr(0, 2)), parseInt(this.selectTime.substr(3, 2)), 0));
            if (checkDate < new Date()) {
                return this.$vs.notify({
                    text: 'Thời gian đặt lịch không hợp lệ!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/create', payload).then(() => {
                this.$vs.notify({
                    text: `Tạo mới lịch hẹn thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.popupBooking = false;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
}
</script>

<style lang="scss">
.popupError .vs-popup--header {
    background: rgba(var(--vs-danger), 1) !important;
}

@media (min-width: 1200px) {
    [dir] .main-horizontal.navbar-sticky .router-content {
        margin-top: 4rem !important;
    }
}

#customer-manage {
    .vs-con-table {
        overflow-y: scroll;
        height: 600px !important;

        .vs-table--content {
            overflow: visible !important;

            .vs-con-tbody {
                overflow: visible !important
            }

            .vs-table--thead th {
                position: sticky;
                top: 0;
                background: #FFFFFF;
                z-index: 999;
            }

            tr:nth-child(even) {
                background-color: #f8f8f8;
            }
        }
    }

    .vs-table--thead tr th:last-child .vs-table-text {
        width: 100px;
    }

    .ag-grid-cell-chip-customer {
        &.vs-chip-success {
            background: rgba(var(--vs-success), .2);
            color: rgba(var(--vs-success), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-warning {
            background: rgba(var(--vs-warning), .2);
            color: rgba(var(--vs-warning), 1) !important;
            font-weight: 500;
        }
    }
}

.consultation_call {
    .vs-popup--header {
        //display: none;
    }

    .vs-popup--content {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
    }

    .view_details_call {
        .vx-row {
            margin: 0 !important;
        }
    }
}

#customer_note {
    .vs-con-textarea {
        height: 300px;

        textarea {
            height: 300px;
        }
    }
}

#customer_info_popup {

    .vs-popup {
        width: 100%;
    }

    .vs-textarea {
        height: 200px;
    }

    .vs-popup--content {
        min-height: 500px;

        .con-slot-tabs {
            min-height: 500px;
        }
    }

    .scroll-area--nofications-dropdown,
    .scroll-area--cart-items-dropdowm {
        max-height: 40rem;
    }

    .flip-card {
        background-color: transparent;
        width: 300px;
        height: 150px;
        perspective: 1000px;
        font-family: sans-serif;
    }

    .title {
        font-size: 1.5em;
        font-weight: 900;
        text-align: center;
        margin: 0;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front,
    .flip-card-back {
        box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        border-radius: 1rem;
    }

    .flip-card-back {
        transform: rotateY(180deg);
    }
}

#popup-history-call {
    .vs-popup--header {
        display: none;
    }
}

#popup-history-call-record {
    .vs-popup--header {
        display: none;
    }
}

.nostar_desc {
    display: none !important;
}

#call_history {
    min-height: 400px;
}

#popup_beauty_booking {
    z-index: 54000 !important;
}
</style>
